import { render, staticRenderFns } from "./fwgl.vue?vue&type=template&id=3ef2a38e&scoped=true&"
import script from "./fwgl.vue?vue&type=script&lang=js&"
export * from "./fwgl.vue?vue&type=script&lang=js&"
import style0 from "./fwgl.vue?vue&type=style&index=0&id=3ef2a38e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef2a38e",
  null
  
)

export default component.exports